import { ResponseMessage } from '@sdbn/appclient';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { TransportOption, TransportOptionColumn, TransportOptionSelection, TransportOptionsPanelModel } from 'src/tmc-yard/components/transport-options-panel/transport-options-panel.model';
import { YardConfiguration } from 'src/tmc-yard/client/model/yard-configuration';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { FormControl, FormControlName, FormGroup } from '@angular/forms';
import { TransportCreationProfile, TransportCreationProfileGroup } from 'src/tmc-yard/client/model/station-usage.model';

export class TransportCreationProfileSelectionDialogData {
  transportCreationProfileGroups = new Array<TransportCreationProfileGroup>();
  responseMessages: ResponseMessage[];
}


@Component({
  selector: 'app-transport-creation-profile-selection',
  templateUrl: './transport-creation-profile-selection.component.html',
  styleUrls: ['./transport-creation-profile-selection.component.scss']
})
export class TransportCreationProfileSelectionComponent implements OnDestroy {

  @Output() public transportCreationProfileSelected = new EventEmitter<TransportCreationProfile>();

  constructor(
    public dialogRef: MatDialogRef<TransportCreationProfileSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TransportCreationProfileSelectionDialogData,
    public dialog: MatDialog,
    public translationService: TranslationService,
    private tmcContextService: TmcContextService
  ) {

  }

  ngOnDestroy() {

  }

  createNewTransportWithVehicle(selectedTransportCreationProfile: TransportCreationProfile) {
    this.transportCreationProfileSelected.emit(selectedTransportCreationProfile);
  }

  public cancel() {
    this.dialogRef.close(null);
  }

}
